import apiClient from "../apiClient";

const addAdmin = (data) => apiClient.post("/admin/add-admin", data);

const deleteAdmin = (data) =>
  apiClient.delete(`/admin/delete-admin/`, { data: data });

export default { addAdmin, deleteAdmin };
